import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

export const EfficaciteetSoins = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl text-center mb-8">
                        Efficacité & Bénéfices des Soins
                    </h1>

                    <div className="space-y-6 text-gray-600 text-base sm:text-lg leading-relaxed">
                        <p>
                            La chiropraxie se distingue par une <strong className="text-gray-800">approche globale</strong>, qui intègre l'histoire personnelle et médicale de chaque patient, ainsi que ses antécédents familiaux, ses habitudes de vie et son environnement professionnel.
                        </p>

                        <p>
                            Cette profession est reconnue depuis <strong className="text-gray-800">2002 en France</strong> et dans plus de 40 autres pays à travers le monde. Profession manuelle de référence pour le traitement du dos et des articulations, la chiropraxie se classe comme la <strong className="text-gray-800">troisième profession de santé aux États-Unis</strong>.
                        </p>

                        <div className="bg-gray-50 rounded-xl p-6 my-8">
                            <p className="text-gray-700">
                                En tant que <strong>thérapeute de première intention</strong>, le chiropracteur peut être consulté directement, sans passer par un médecin traitant. Il est formé pour offrir une prise en charge adaptée et orienter les patients vers un médecin si un avis médical est nécessaire.
                            </p>
                        </div>

                        <h2 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-xl sm:text-2xl mt-10 mb-6">
                            Les bénéfices de la chiropraxie
                        </h2>

                        <div className="space-y-8">
                            <div className="border-l-4 pl-6" style={{ borderColor: Helper.footerBackGroundColor }}>
                                <h3 className="font-semibold text-gray-800 text-lg mb-2">1. Soulagement de la douleur</h3>
                                <p>La chiropraxie est efficace pour soulager les douleurs du bas du dos, du cou et des articulations. Les ajustements chiropratiques peuvent offrir un soulagement similaire aux traitements conventionnels pour les lombalgies, douleurs cervicales et articulaires.</p>
                            </div>

                            <div className="border-l-4 pl-6" style={{ borderColor: Helper.footerBackGroundColor }}>
                                <h3 className="font-semibold text-gray-800 text-lg mb-2">2. Amélioration de la mobilité et de la flexibilité</h3>
                                <p>La chiropraxie aide à restaurer la mobilité des articulations qui peuvent être restreintes en raison de tensions musculaires, d'une mauvaise posture ou de blessures. Cela permet une meilleure amplitude de mouvement et plus de flexibilité.</p>
                            </div>

                            <div className="border-l-4 pl-6" style={{ borderColor: Helper.footerBackGroundColor }}>
                                <h3 className="font-semibold text-gray-800 text-lg mb-2">3. Une alternative conservatrice à la chirurgie</h3>
                                <p>La chiropraxie est une approche non invasive qui peut parfois éviter ou retarder une chirurgie de la colonne vertébrale ou la pose d'une prothèse articulaire. Elle offre une alternative conservatrice, permettant de traiter les problèmes sans avoir recours à des interventions chirurgicales ou à des médicaments.</p>
                            </div>

                            <div className="border-l-4 pl-6" style={{ borderColor: Helper.footerBackGroundColor }}>
                                <h3 className="font-semibold text-gray-800 text-lg mb-2">4. Prévention des blessures</h3>
                                <p>En maintenant une bonne posture, une flexibilité adéquate et en réduisant les déséquilibres musculaires, la chiropraxie peut aider à prévenir les blessures, notamment dans les sports ou les activités physiques.</p>
                            </div>

                            <div className="border-l-4 pl-6" style={{ borderColor: Helper.footerBackGroundColor }}>
                                <h3 className="font-semibold text-gray-800 text-lg mb-2">5. Amélioration de la qualité de vie</h3>
                                <p>En réduisant la douleur, en améliorant la mobilité, et en augmentant le bien-être général, la chiropraxie peut améliorer la qualité de vie des patients, leur permettant de mener une vie plus active et épanouie.</p>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-center mt-10">
                        <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                            Prendre rendez-vous
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
